<template>
  <div class="min-vh-100">
    <div v-if="isAdmin">
      <router-view :searchCourse="search"></router-view>
    </div>
    <div class="min-vh-100" v-else>
      <Header @search="searchData" />
      <router-view :searchCourse="search"></router-view>
      <Footer class="d-md-down-none" />
      <FooterMobile class="d-xl-none d-lg-none" />
    </div>
  </div>
</template>

<script>
import TheAdminSidebar from "../src/containers/admin/TheAdminSidebar";
import TheAdminHeader from "../src/containers/admin/TheAdminHeader";
import TheAdminFooter from "../src/containers/admin/TheAdminFooter";
import { mapGetters } from "vuex";

export default {
  name: "App",
  components: {
    TheAdminSidebar,
    TheAdminFooter,
    TheAdminHeader,
  },
  data() {
    return {
      search: "",
      isAdmin: false,
    };
  },
  created() {
  },
  computed: {
    ...mapGetters({
      headerStatusGetter: "language/getChangingSidebarStatus",
    }),
  },
  watch: {
    headerStatusGetter: function (val) {
      this.isAdmin = val;
      // console.log("change!! , val =>",this.isAdmin);
    },
  },
  methods: {
    searchData(value) {
      this.search = value;
    },
  },
};
</script>

<style lang="scss">
// Import Main styles for this application
@import "assets/scss/style";
</style>
